// Centrale API base-URL.
// - Web (browser): REACT_APP_BACKEND_URL uit .env (build-time)
// - Desktop (Electron): de lokale sync-gateway (offline cache + wachtrij), via preload bridge
export const API_BASE =
  (typeof window !== 'undefined' && window.electron?.isElectron && window.electron.apiBase) ||
  process.env.REACT_APP_BACKEND_URL;
